<template>
  <div id="inactivity-inbox-messages-list">

    <setting-view-sidebar
      v-if="sidebarData.id !== undefined"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @updateMessages="fetchMessages"
      :setting="sidebarData"
    />

    <vs-table
      :sst="true"
      ref="table"
      noDataText="Sem dados disponíveis"
      :max-items="100"
      search
      :data="messages"
    >
      <template slot="thead">
        <vs-th sort-key="name">Mensagens</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                v-if="canSee('inactive')"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import SettingViewSidebar from '@/views/messages/MessageInactiveInboxViewSidebar'
  import { hasPermission } from '@/utils'
  import requests from '@/http/requests/messages'

  export default {
    name: 'settings-messages-inactive-inbox',
    components: {
      SettingViewSidebar,
    },
    data() {
      return {
        messages: [],
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
      }
    },
    methods: {
      getNumberStatusName(isBlacklisted) {
        if (isBlacklisted !== false && isBlacklisted !== 'false' && isBlacklisted !== 0 && isBlacklisted !== '0') { 
          return 'Bloqueado'
        }

        return 'Ativo'
      },
      getNumberStatusColor(isBlacklisted) {
        if (isBlacklisted !== false && isBlacklisted !== 'false' && isBlacklisted !== 0 && isBlacklisted !== '0') {
          return 'dark'
        }

        return 'success'
      },
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      editData(data) {
        this.sidebarData = this.$_.cloneDeep(data)
        this.toggleDataSidebar(true)
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      canSee(action) {
        return hasPermission(`settings-messages-inbox-${action}`)
      },
      fetchMessages() {
        this.messages = [];
        this.$store.dispatch('setShowLoadingOverlay', true)

        requests.fetch().then((response) => {
          this.messages = response.data.data.messages.filter(message => ![
            'Mensagem de NPS',
            'Mensagem enviada no encerramento do chat',
            'Mensagem de Inatividade'
          ].includes(message.name));
          this.$store.dispatch('setShowLoadingOverlay', false)
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          console.log(error)
        })
      }
    },
    created() {
      this.fetchMessages()
    },
    beforeRouteLeave(to, from, next) {
      if (this.addNewDataSidebar) {
        this.addNewDataSidebar = false;
        setTimeout( ()=> {
          next();
        }, 2);
      } 
      else {
        next();
      }
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
#inactivity-inbox-messages-list  {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.5rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 10px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }

          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
